import { Button, Message, toaster } from "rsuite";
import { useState } from "react";
import InputMask from "react-input-mask";
import {PhoneInputProps} from "./PhoneInput.model";
import { TechnicalApi } from "../../../services/Technical.api";

const PhoneInput = ({ deviceId }: PhoneInputProps) => {
  const [phone, setPhone] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPhone(value);

    const isPhoneValid = !value.includes("_") && value.replace(/\D/g, "").length === 11;
    setIsValid(isPhoneValid);
  };

  const sendSms = async (phoneNumber: string) => {
    try {
      setLoading(true);
      await TechnicalApi.sendSms(String(deviceId), phoneNumber);

      toaster.push(
        <Message type="success" closable>
          СМС успешно отправлено на номер {phoneNumber}
        </Message>,
        { placement: "topCenter", duration: 5000 }
      );
    } catch (error) {
      console.error("Ошибка при отправке СМС:", error);

      const message = error instanceof Error ? error.message : "Неизвестная ошибка";
      toaster.push(
        <Message type="error" closable>
          Ошибка при отправке СМС: {message}
        </Message>,
        { placement: "topCenter", duration: 5000 }
      );

      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!isValid) {
      console.log("Номер телефона невалидный");
      toaster.push(
        <Message type="warning" closable>
          Введите корректный номер телефона
        </Message>,
        { placement: "topCenter", duration: 3000 }
      );
      return;
    }

    let cleanPhone = phone.replace(/\D/g, "");

    if (cleanPhone.startsWith("7") && cleanPhone.length === 11) {
      cleanPhone = "+" + cleanPhone;
    }

    try {
      await sendSms(cleanPhone);
      setPhone("");
      setIsValid(false);
    } catch (error) {
    }
  };

  return (
    <div className="phone-input">
      <div className="row">
        <div className="col">
          <InputMask
            mask="+7 (999) 999-99-99"
            value={phone}
            onChange={handlePhoneChange}
            maskChar={null}
            className="rs-input"
            placeholder="+7 (___) ___-__-__"
            style={{
              width: 220,
              padding: "8px 12px",
              border: `1px solid ${!isValid && phone ? "#f44336" : "#e5e5ea"}`,
              borderRadius: "6px",
              fontSize: "14px"
            }}
          />
        </div>
        <div className="col">
          <Button
            onClick={handleSubmit}
            disabled={!isValid || loading}
            loading={loading}
          >
            {loading ? "Отправка..." : "Отправить"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
